import { useState } from 'react';
import './AdminLogin.css';

export default function AdminLogin({ onUnlock }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_ADMIN_PASSWORD) {
      localStorage.setItem('admin-unlocked', 'true');
      onUnlock();
    } else {
      setError('Incorrect password.');
      setPassword('');
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-icon">🔒</div>
        <h1 className="login-title">Admin access</h1>
        <p className="login-subtitle">Enter your password to manage listings.</p>
        <form onSubmit={handleSubmit}>
          <input
            className="login-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => { setPassword(e.target.value); setError(''); }}
            autoFocus
          />
          {error && <div className="login-error">{error}</div>}
          <button className="login-btn" type="submit">Unlock</button>
        </form>
      </div>
    </div>
  );
}
